import React from 'react';

const InfoCard = ({ onClose }) => {
  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-lg">
        <h2 className="text-2xl font-bold mb-4">Welcome to Aceternity</h2>
        <p className="mb-4">This is the central info card. Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
        <button className="bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 rounded" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default InfoCard;